import React from 'react';

const DownloadListSvg = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.00033 11.3332C1.63366 11.3332 1.31988 11.2027 1.05899 10.9418C0.797659 10.6805 0.666992 10.3665 0.666992 9.99984V7.99984H2.00033V9.99984H10.0003V7.99984H11.3337V9.99984C11.3337 10.3665 11.2032 10.6805 10.9423 10.9418C10.681 11.2027 10.367 11.3332 10.0003 11.3332H2.00033ZM6.00033 8.6665L2.66699 5.33317L3.60033 4.3665L5.33366 6.09984V0.666504H6.66699V6.09984L8.40033 4.3665L9.33366 5.33317L6.00033 8.6665Z"
                fill="#1D74DD"/>
        </svg>
    );
};

export default DownloadListSvg;